export default function(h, row, index) {
    let _s1 =  '#' + row.user_id + ': ' +  row.user_firstname + ' ' + row.user_lastname + ' (' + row.user_login + ')';
    let _s2 =  '#' +  row.company_id +': ' + row.company_title;

    if (row.company_id === row.doc_company_id)
        return <span><span class="vouchers_table__user">{_s1}</span><br /><span class="vouchers_table__company">{_s2}</span></span>

    let _s3 =  + '#' +  row.doc_company_id + ': ' + row.doc_company_title;

    return <span>{row.doc_company_id}</span>

}
